module.exports = __webpack_public_path__ + "gxqgouche2212/static/img/empty.47040b50.png";